import MessengerCustomerChat from "react-messenger-customer-chat";
import 'react-tiny-fab/dist/styles.css';
import './blcmessenger.css';
const cors = require('cors');
const BlcMessenger = () => {

  return (
    <>
      <div>
        {
          cors() &&
          <MessengerCustomerChat
            pageId="103146218955621"
            appId="355452463070676"
            themeColor={'#ec008c'}
          />
        }
      </div>
    </>
  );
};

export default BlcMessenger;
